import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { AutoCompleteExtraProps, BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { SalaryDraftFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { useSalaryService } from "serviceHooks";
//#endregion

const SalaryDraftForwardForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const salaryService = useSalaryService();
  return (
    <GenericForm<SalaryDraftFormTypes.Assign>
      formRef={ref}
      {...props}
      fields={{
        assignPersonName: {
          label: TranslationKeys.Salary.SalaryDraftReceiver,
          descriptionText: TranslationKeys.Salary.SalaryDraftReceiverHelpText,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          icon: IconDefinitionConstants.WUser,
          extraProps: {
            items: salaryService.searchSalaryAdmins,
            referenceFieldName: FormFieldConstants.SalaryDraft.Assign.AssignPersonId,
          } as AutoCompleteExtraProps<SalaryDraftFormTypes.Assign>,
        },
        message: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
        },
      }}
    />
  );
};

export default forwardRef(SalaryDraftForwardForm);
